import React, {useContext} from 'react';
import { Link } from 'react-router-dom'

import TranslationContext from '../../../../../context/TranslationContext'
import Button from "../../../../common/Button";

const EsiaAuth = ({disable = false}) => {
    const {getTranslation} = useContext(TranslationContext)

    if (disable) {
        return <Button
            idPhrase={"btn_gsu"}
            disabled={disable}
        />
    }

    return (
        <Link
            // disable={disable}
            to='/api/v1/esia/redirect'
            className='btn element-border'
        >
        {getTranslation("btn_gsu")}
        </Link>
    )
}
export default EsiaAuth;